import { Schema } from "effect"
import { Persistence } from "@/runtime/persistence/schema"
import { ServerKey } from "@/runtime/server/persistence"
import { pathKey } from "@/workspaces/path-key"

export const SidebarSessionSchema = Persistence.struct({
  type: Schema.Literal("session"),
  server: ServerKey,
  sessionID: Schema.String,
  title: Persistence.optional(Schema.String),
  directory: Persistence.optional(Schema.String),
  projectID: Persistence.optional(Schema.String),
})

export const SidebarProjectSchema = Persistence.struct({
  type: Schema.Literal("project"),
  server: ServerKey,
  directory: Schema.String,
  projectID: Persistence.optional(Schema.String),
  title: Persistence.optional(Schema.String),
})

export const SidebarRefSchema = Schema.Union([SidebarSessionSchema, SidebarProjectSchema])
export type SidebarSessionRef = typeof SidebarSessionSchema.Type
export type SidebarProjectRef = typeof SidebarProjectSchema.Type
export type SidebarProject = SidebarProjectRef
export type SidebarRef = typeof SidebarRefSchema.Type

export function sidebarKey(ref: SidebarRef) {
  return JSON.stringify([ref.type, ref.server, ref.type === "session" ? ref.sessionID : pathKey(ref.directory)])
}

export const SidebarSortSchema = Schema.Literals(["manual", "updated", "attention"])
export type SidebarSort = typeof SidebarSortSchema.Type
export const SidebarProjectListSortSchema = Schema.Literals(["manual", "updated"])
export type SidebarProjectListSort = typeof SidebarProjectListSortSchema.Type

export const SidebarStateSchema = Persistence.struct({
  pins: Persistence.array(SidebarRefSchema),
  pinnedSort: SidebarSortSchema,
  pinnedExpanded: Schema.Boolean,
  projectsExpanded: Schema.Boolean,
  projectExpanded: Persistence.record(Schema.Boolean),
  projectListSort: Persistence.optional(SidebarProjectListSortSchema),
  projectListOrder: Persistence.array(Schema.String),
  projectOrder: Persistence.record(Persistence.array(Schema.String)),
  sessionOrder: Persistence.record(Persistence.array(Schema.String)),
  sessionSort: Persistence.record(SidebarSortSchema),
})
export type SidebarState = typeof SidebarStateSchema.Type

export function initialSidebarState(): SidebarState {
  return {
    pins: [],
    pinnedSort: "manual",
    pinnedExpanded: true,
    projectsExpanded: true,
    projectExpanded: {},
    projectListOrder: [],
    projectOrder: {},
    sessionOrder: {},
    sessionSort: {},
  }
}
